import { Theme } from "@mui/material";
const Scrollbar = (theme: Theme) => {
  return {
    "@global": {
      "*::-webkit-scrollbar": {
        width: "0.4em",
      },
      "*::-webkit-scrollbar-track": {
        "-webkit-box-shadow": "inset 0 0 10px rgba(0,0,0,0.00)",
      },
      "*::-webkit-scrollbar-thumb": {
        backgroundColor: "rgba(0,0,0,.1)",
        outline: "5px solid slategrey",
      },
    },
  };
};

export default Scrollbar;
